module.exports = {
	REQUEST_CONDITION: "REQUEST_CONDITION",
	RECEIVE_CONDITION: "RECEIVE_CONDITION",
    REQUEST_CONDITION_ERROR: "REQUEST_CONDITION_ERROR",
    RESET_CONDITION: "RESET_CONDITION",
	REQUEST_CONDITIONS: "REQUEST_CONDITIONS",
	RECEIVE_CONDITIONS: "RECEIVE_CONDITIONS",
    SET_ACTIVE_CONDITION: "SET_ACTIVE_CONDITION",
    RESET_ACTIVE_CONDITION: "RESET_ACTIVE_CONDITION",
    SET_ACTIVE_INTERVENTION: "SET_ACTIVE_INTERVENTION",
    RESET_ACTIVE_INTERVENTION: "RESET_ACTIVE_INTERVENTION",
    SET_FEATURED_PLACEMENT: "SET_FEATURED_PLACEMENT",
    RESET_FEATURED_PLACEMENT: "RESET_FEATURED_PLACEMENT",
    SET_SPONSORED_PLACEMENT: "SET_SPONSORED_PLACEMENT",
    RESET_SPONSORED_PLACEMENT: "RESET_SPONSORED_PLACEMENT"
};



// WEBPACK FOOTER //
// ./src/common/modules/conditions/constants.js